import MenuCategory from ".";


export const menuCategoryRoutes = () => [
  {
    path: "/admin/menu-categories",
    component: MenuCategory,
    layout: "admin",
    routeType: "admin",
    title: "Menu Category Management",
  },
];
